import React from "react";
import { Helmet } from "react-helmet-async";
import AccountLogin from "../../../components/desktop/account-login";
import { appUrl } from "../../../constants/url-constants";

const AccountLoginContainer = () => {
    return (
        <React.Fragment>
            <Helmet>
                <title>Cars24 Login</title>
                <meta
                    name="description"
                    content="Login to Cars24 for a seamless buying or selling of a car.
                        Log in to check the status of your transaction with ease.
                        Simplify the car trading process with Cars24 today!"
                />
                <link href={`${appUrl()}/account/login/`} rel="canonical" />
                <meta name="ROBOTS" content="NOINDEX,NOFOLLOW" />
            </Helmet>
            <AccountLogin />
        </React.Fragment>
    );
};

export default AccountLoginContainer;
